import EditPatientScreen from './EditPatientScreen';
export default EditPatientScreen;
